import { useCallback, useRef } from 'react';

const useThrottle = (callback: Function, delay: number) => {
  const lastRun = useRef(Date.now());
  const timeout = useRef<NodeJS.Timeout>();

  return useCallback(() => {
    if (timeout.current) {
      return;
    }

    const now = Date.now();
    const timeSinceLastRun = now - lastRun.current;

    if (timeSinceLastRun >= delay) {
      callback();
      lastRun.current = now;
    } else {
      timeout.current = setTimeout(() => {
        callback();
        lastRun.current = Date.now();
        timeout.current = undefined;
      }, delay - timeSinceLastRun);
    }
  }, [callback, delay]);
};

export default useThrottle;
